import { combineReducers } from "redux";
import ClientTab from "./containers/ClientTab";
import AddNewClient  from "./containers/AddNewClient";
import AddNewRole from "./containers/AddNewRole";
import AddNewUser from "./containers/AddNewUser";
import EditClientDialog from "./components/EditClientDialog";
import EditRoleDialog from "./components/EditRoleDialog";
import EditUserDialog from "./components/EditUserDialog";
import clientReducer from "./reducers/clientReducer";
import rolesReducer from "./reducers/rolesReducer";
import usersReducer from "./reducers/usersReducer";

const components = { ClientTab, AddNewClient, EditClientDialog, EditUserDialog, AddNewRole, EditRoleDialog, AddNewUser };

const reducers = combineReducers({
  clientMgmt: clientReducer,
  rolesManagement: rolesReducer,
  usersManagement: usersReducer
});

export { components, reducers };
